<small class="debug">{{me}}</small>
<div style="padding: 5px 0;">
    <!-- <app-add-node (addedNode)="addNode($event)" [isTop]="true"></app-add-node> -->
    <!-- <div class="pull-right">
        <mat-checkbox (change)="toggleSelection($event)">set as null</mat-checkbox>
    </div> -->
    <!-- <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="pull-right">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </div> -->
</div>

<div style="height: 500px; overflow-y: auto;">
    <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="static-tree-wrapper mat-tree-position">
        <mat-tree-node *matTreeNodeDef="let node">
            <li class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': (clickSelection.isSelected(node) || selectedTreePath == node.TreePath) ? markTreeSelection : null}">
                <button mat-icon-button disabled></button>
                {{node.Name}}
                <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
            </li>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
            <li >
                <div class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': (clickSelection.isSelected(node) || selectedTreePath == node.TreePath) ? markTreeSelection : null}">
                    <button mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'toggle ' + node.Name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    {{node.Name}}
                    <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
                </div>
                <ul [class.tree-wrapper-invisible]="!nestedTreeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
</div>
